import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env';

export interface RegisterUserDto {
  userName: string;
  email: string;
  name: string;
  address: string;
  address2?: string;
  city: string;
  state: string;
  postalCode: string;
  company?: string;
  password: string;
  roles: string[];
}

export interface RegisteredUser {
  id: string;
  userName: string;
  email: string;
  name: string;
  address: string;
  address2?: string;
  city: string;
  state: string;
  postalCode: string;
  company?: string;
  password: string;
  roles: string[];
}

@Injectable({
  providedIn: 'root',
})
export class IdentityApiService {
  private readonly baseUrl = `${environment.ApiBaseUrl}/api/auth`;

  constructor(private http: HttpClient) {}

  registerUser(user: RegisterUserDto): Observable<RegisteredUser> {
    return this.http.post<RegisteredUser>(`${this.baseUrl}/register`, user);
  }

  requestPasswordReset(userIdentifier: string): Observable<object> {
    return this.http.post(`${this.baseUrl}/request-password-reset`, {
      identifier: userIdentifier,
    });
  }

  resetPassword(
    userId: string,
    token: string,
    newPassword: string
  ): Observable<object> {
    return this.http.post(`${this.baseUrl}/reset-password/${userId}`, {
      password: newPassword,
      token,
    });
  }
}
